/* eslint-disable import/no-mutable-exports */
/* eslint-disable prefer-const */
/* eslint-disable sonarjs/cognitive-complexity */
import { transactionDocumentTypes } from './confirmation'
import { employeeSearchFields } from './employee'
import { isAdmin, isAdminOrOperator, isOperator } from './roles'
import { capitalized, extractCityStateListing, formatDate, formatDateWithoutTime, getFormattedAmount, isConfidential, isValue } from '@/helpers'
import type { ISearchUsers } from '@/interface'
import i18n from '@/plugins/i18n/index'

export const usersTypesOptions = ['Loader', 'Trucker']

export const loadsFreight = [{ text: 'Per Ton', value: 'per_ton' },
  { text: 'Per Unit', value: 'per_unit' },
  { text: 'Total Freight', value: 'total_freight' },
  { text: 'All', value: '' }]

export const businessCluster = [i18n.global.t('users.all_clusters')]
export const products = [i18n.global.t('users.all_products')]
export const industries = [i18n.global.t('users.all_industries')]
export const verification = [{ text: i18n.global.t('general.verified'), value: '1' },
  { text: i18n.global.t('general.unverified'), value: '0' },
  { text: i18n.global.t('general.all'), value: '' }]

export const activeOptions = [
  { text: i18n.global.t('Active'), value: '1' },
  { text: i18n.global.t('Inactive'), value: '0' },
  { text: i18n.global.t('general.all'), value: '' },
]

export const truckTyres = [
  { text: 'All', value: '' },
  { text: '4W - 1 Ton', value: '1' },
  { text: '4W - 2 Tons', value: '2' },
  { text: '4W - 3 Tons', value: '3' },
  { text: '4W - 4 Tons', value: '4' },
  { text: '4W - 5 Tons', value: '5' },

  { text: '6W - 6 Tons', value: '6' },
  { text: '6W - 7 Tons', value: '7' },
  { text: '6W - 8 Tons', value: '8' },
  { text: '6W - 9 Tons', value: '9' },
  { text: '6W - 10 Tons', value: '11' },
  { text: '6W - 11 Tons', value: '19' },
  { text: '6W - 12 Tons', value: '13' },
  { text: '6W - 13 Tons', value: '15' },
  { text: '6W - 14 Tons', value: '17' },
  { text: '6W - 15 Tons', value: '20' },
  { text: '6W - 16 Tons', value: '21' },

  { text: '10W', value: '10' },
  { text: '12W', value: '12' },
  { text: '14W', value: '14' },
  { text: '16W', value: '16' },
  { text: '18W and above', value: '18' },
]

export const offerSuggestionTyres = [
  { text: 'All', value: 'all' },
  ...truckTyres.slice(1),
]

export const truckCapacity = [
  { text: 'All', value: '' },
  { text: '1-5 tons', value: '4' },
  { text: '6-16 tons', value: '5' },
  { text: '17-21 tons', value: '0' },
  { text: '22-25 tons', value: '1' },
  { text: '26-30 tons', value: '2' },
  { text: '31-35 tons', value: '3' },
  { text: '36-50 tons', value: '6' },
]

// Load capacities. A range with `min` accepts any weight from `min` to `max` inclusive,
// past its `nominal` tonnage, so it overlaps its neighbours (see isWeightInCapacity).
// `nominal` is the tonnage the label names: the point capacities aim at it and only
// reach for `max` once they pass it.
// Trucks and offers keep the plain ranges in truckCapacity.
export const addTruckCapacity = [
  { text: '1-5 tons', value: '4', max: 5 },
  { text: '6-16 tons', value: '5', max: 16 },
  { text: '17-21 tons', value: '0', max: 21 },
  { text: '12 W - 25 Tons', value: '1', min: 20, max: 40, nominal: 25 },
  { text: '14 W - 30 Tons', value: '2', min: 20, max: 40, nominal: 30 },
  { text: '16 W - 35 Tons', value: '3', min: 20, max: 40, nominal: 35 },
  { text: '36-50 tons', value: '6', max: 50 },
]

const loadCapacityOptions = addTruckCapacity.map(({ text, value }) => ({ text, value }))

export const loadCapacity = [{ text: 'All', value: '' }, ...loadCapacityOptions]

export const loadSuggestionCapacity = [{ text: 'All', value: 'all' }, ...loadCapacityOptions]

export const truckTyreCapacity = [
  { id: '4', tyre: '4', value: '1-5 tons', tyreTitle: '4', tyreUpdatedTitle: '4W - 1 Ton', mappedValue: '1' },
  { id: '4', tyre: '4', value: '1-5 tons', tyreTitle: '4', tyreUpdatedTitle: '4W - 2 Tons', mappedValue: '2' },
  { id: '4', tyre: '4', value: '1-5 tons', tyreTitle: '4', tyreUpdatedTitle: '4W - 3 Tons', mappedValue: '3' },
  { id: '4', tyre: '4', value: '1-5 tons', tyreTitle: '4', tyreUpdatedTitle: '4W - 4 Tons', mappedValue: '4' },
  { id: '4', tyre: '4', value: '1-5 tons', tyreTitle: '4', tyreUpdatedTitle: '4W - 5 Tons', mappedValue: '5' },
  { id: '5', tyre: '6', value: '6-16 tons', tyreTitle: '6', tyreUpdatedTitle: '6W - 6 Tons', mappedValue: '6' },
  { id: '5', tyre: '6', value: '6-16 tons', tyreTitle: '6', tyreUpdatedTitle: '6W - 7 Tons', mappedValue: '7' },
  { id: '5', tyre: '6', value: '6-16 tons', tyreTitle: '6', tyreUpdatedTitle: '6W - 8 Tons', mappedValue: '8' },
  { id: '5', tyre: '6', value: '6-16 tons', tyreTitle: '6', tyreUpdatedTitle: '6W - 9 Tons', mappedValue: '9' },
  { id: '5', tyre: '6', value: '6-16 tons', tyreTitle: '6', tyreUpdatedTitle: '6W - 10 Tons', mappedValue: '11' },
  { id: '5', tyre: '6', value: '6-16 tons', tyreTitle: '6', tyreUpdatedTitle: '6W - 11 Tons', mappedValue: '19' },
  { id: '5', tyre: '6', value: '6-16 tons', tyreTitle: '6', tyreUpdatedTitle: '6W - 12 Tons', mappedValue: '13' },
  { id: '5', tyre: '6', value: '6-16 tons', tyreTitle: '6', tyreUpdatedTitle: '6W - 13 Tons', mappedValue: '15' },
  { id: '5', tyre: '6', value: '6-16 tons', tyreTitle: '6', tyreUpdatedTitle: '6W - 14 Tons', mappedValue: '17' },
  { id: '5', tyre: '6', value: '6-16 tons', tyreTitle: '6', tyreUpdatedTitle: '6W - 15 Tons', mappedValue: '20' },
  { id: '5', tyre: '6', value: '6-16 tons', tyreTitle: '6', tyreUpdatedTitle: '6W - 16 Tons', mappedValue: '21' },
  { id: '0', tyre: '10', value: '17-21 tons', tyreTitle: '10', tyreUpdatedTitle: '10W', mappedValue: '10' },
  { id: '1', tyre: '12', value: '22-25 tons', tyreTitle: '12', tyreUpdatedTitle: '12W', mappedValue: '12' },
  { id: '2', tyre: '14', value: '26-30 tons', tyreTitle: '14', tyreUpdatedTitle: '14W', mappedValue: '14' },
  { id: '3', tyre: '16', value: '31-35 tons', tyreTitle: '16', tyreUpdatedTitle: '16W', mappedValue: '16' },
  { id: '6', tyre: '18', value: '36-50 tons', tyreTitle: '18W and above', tyreUpdatedTitle: '18W and above', mappedValue: '18' },
]

export const visibility = [
  { text: i18n.global.t('general.public'), value: '1' },
  { text: i18n.global.t('general.private'), value: '0' },
]

export const offerOrLoadVisibility = [
  { text: i18n.global.t('general.private'), value: 0 },
  { text: i18n.global.t('general.public'), value: 1 },
]

export const bankTypes = [i18n.global.t('bank.saving_account'),
  i18n.global.t('bank.current_account'),
  i18n.global.t('bank.salary_account'),
  i18n.global.t('bank.fixed_account'),
  i18n.global.t('bank.recurring_account'),
  i18n.global.t('bank.nri_account')]

export const smsTemplate = ['SMS Sample Static template']

export const exportType = [{ title: 'Daily', value: 'daily' }, { title: 'Weekly', value: 'weekly' }, { title: 'Month', value: 'month' }, { title: 'Yearly', value: 'yearly' }, { title: 'Custom', value: 'custom' }]

export const usersColumnsBold = [i18n.global.t('users.business_name'), i18n.global.t('users.business_area'), i18n.global.t('users.trading_name'), i18n.global.t('users.business_cluster')]

export const usersSelectOptions = [
  i18n.global.t('general.active'),
  i18n.global.t('general.inactive'),
  i18n.global.t('general.verified'),
  i18n.global.t('general.unverified'),

  // i18n.global.t('general.delete'), => temporarily committed as per the requirement
]

export const usersSelectedOptions = [
  i18n.global.t('general.available'),
  i18n.global.t('general.in_process'),
  i18n.global.t('general.public'),
  i18n.global.t('general.private'),
  i18n.global.t('general.cancel'),
  i18n.global.t('general.delete'),
]

// admin status
export const usersSelectedOptionsWithDisable = [
  {
    text: 'Available',
    value: 'Available',
    disabled: true,
  },
  {
    text: 'In process',
    value: 'In process',
    disabled: true,
  },
  {
    text: 'Public',
    value: 'Public',
    disabled: true,
  },
  {
    text: 'Private',
    value: 'Private',
    disabled: true,
  },
  {
    text: 'Cancel',
    value: 'Cancel',
    disabled: true,
  },
  {
    text: 'Delete',
    value: 'Delete',
  },
]

// Loader and trucker Status
export const selectOptionsWithDisableLoaderTrucker = [

  {
    text: 'Cancel',
    value: 'Cancel',
    disabled: true,
  },
  {
    text: 'Delete',
    value: 'Delete',
    disabled: true,
  },
]

export const bulkUsersStatus = {
  available: 'Available',
  inProcess: 'In process',
  public: 'Public',
  private: 'Private',
  cancel: 'Cancel',
  delete: 'Delete',
  reject: 'Reject',
  decline: 'decline',
}

export const isActionStatus = {
  available: 'Available',
  inProcess: 'In process',
}

export const moduleType = {
  confirmation: 'confirmation',
  quickConfirmation: 'quick-confirmation',
  auditLogs: 'Audit Logs',
}

export const usersSubTypesSelectOptions = [
  i18n.global.t('general.active'),
  i18n.global.t('general.inactive'),
  i18n.global.t('general.delete'),
]

export const freightMethodTypes: any = {
  per_ton: i18n.global.t('Per Ton'),
  per_unit: i18n.global.t('Per Unit'),
  total_freight: i18n.global.t('Total Freight'),
}

export const showFreightMethodTypes: any = {
  per_ton: i18n.global.t('Ton'),
  Tons: i18n.global.t('Ton'),
  per_unit: i18n.global.t('Unit'),
  Units: i18n.global.t('Unit'),
  total_freight: i18n.global.t('Freight'),
}

export const confirmationMenuList = [
  { title: 'Audit Logs', value: 'Audit Logs' },
  { title: 'Confirmation Link', value: 'Confirmation Link' },
  { title: 'Invoices', value: 'Invoices' },
]

export const cnfMenuForLoadAccounts = [
  { title: 'Confirmation Link', value: 'Confirmation Link' },
  { title: 'Invoices', value: 'Invoices' },
]

export const cnfMenuForTruckOps = [
  { title: 'Confirmation Link', value: 'Confirmation Link' },
  { title: 'Transit Documents', value: 'transitDocuments' },
]

export const loadColumn = {
  booked: 'load_booked',
}

export const hasStatusType = {
  active: 'active',
  inactive: 'inactive',
}

export const userActions = {
  add: 'add',
  view: 'view',
  log: 'log',
  edit: 'edit',
  delete: 'delete',
  status: 'status',
  verify: 'verify',
  doc_verify: 'doc_verify',
  cancel: 'cancelled',
  available: 'available',
  inProcess: 'in process',
  public: 'public',
  private: 'private',
  lock: 'lock',
  reload: 'reload',
  repeat: 'repeat',
  unlock: 'unlock',
  booked: 'booked',
  in_process: 'In process',
  Available: 'Available',
  Expiring: 'Expiring',
  Expired: 'Expired',
  Cancelled: 'Cancelled',
  Cancel: 'Cancel',
  Delete: 'Delete',
  docVerify: 'docVerify',
}

export const userActionType = {
  default: 'default',
  view: 'view',
}

export const amountTypes = [
  { title: 'Paid', value: 'Paid' },
  { title: 'Received', value: 'Received' },
]

export const transactionsType = [
  { title: 'Razor Pay', value: 'RAZORPAY' },
  { title: 'A/C Transfer', value: 'NETBANKING' },
  { title: 'Cash', value: 'CASH' },
  { title: 'MC Book', value: 'MC_BOOK' },
  { title: 'Party to Party', value: 'PARTYTOPARTY' },
]

// A transfer records itself, not one of the methods above — kept out of
// createLedgerTransactionType so a plain journal entry is never offered it.
export const partyToPartyTransactionType = [
  { title: 'Party to Party', value: 'PARTYTOPARTY' },
]

export const createLedgerTransactionType = [
  { title: 'A/C Transfer', value: 'NETBANKING' },
  { title: 'Cash', value: 'CASH' },
  { title: 'MC Book', value: 'MC_BOOK' },
]

export const mcBookTransactionType = [
  { title: 'A/C Transfer', value: 'NETBANKING' },
  { title: 'Cash', value: 'CASH' },
]

export const journalUserTypes = [
  { title: 'Loader', value: 'loader' },
  { title: 'Trucker', value: 'trucker' },
  { title: 'Hybrid User', value: 'hybrid' },
]

export const partyTypes = {
  self: 'SELF',
  branch: 'BRANCH',
  loadingPoint: 'LOADING_POINT',
  unloadingPoint: 'UNLOADING_POINT',
}

export const partyGroupLabels: Record<string, string> = {
  [partyTypes.branch]: 'Branch',
  [partyTypes.loadingPoint]: 'Consignor',
  [partyTypes.unloadingPoint]: 'Consignee',
}

export const bannerUserTypeOptions = [{ text: 'Loader', value: 'loader' },
  { text: 'Trucker', value: 'trucker' },
  { text: 'Both', value: 'both' }]

export const loaderPaidToOptions = ['Navodaya', 'Trucker']

export const truckerPaidToOptions = ['Navodaya', 'Loader']

export const ledgerAmountTypes = [
  { text: 'Navodaya Advance', value: 'FREIGHT' },
  { text: 'Navodaya POD', value: 'POD' },
  { text: 'Navodaya To Pay', value: 'TOPAY' },
  { text: 'PR', value: 'PR' },
  { text: 'Commission', value: 'COMMISSION' },
  { text: 'Crossing + Commission', value: 'CROSSING_COMMISSION' },
  { text: 'Cancellation Charges', value: 'CANCELLATION_CHARGES' },
  { text: 'Other Charges', value: 'OTHER_CHARGES' },
  { text: 'Journal', value: 'JOURNAL' },
  { text: 'Other', value: 'PARTYTOPARTY' },
]

// The only amount types a party_to_party_entries row can hold, per CreatePartyToPartyDto
export const partyToPartyAmountTypes = [
  { text: 'Other', value: 'PARTYTOPARTY' },
  { text: 'Party Advance', value: 'FREIGHT' },
  { text: 'Party To Pay', value: 'TOPAY' },
  { text: 'Party POD', value: 'POD' },
  { text: 'Other Charges', value: 'OTHER_CHARGES' },
]

export const addedToLedgerOptions = [
  { text: 'Yes', value: '1' },
  { text: 'No', value: '0' },
]

export const partyRoles = {
  payer: 'PAYER',
  receiver: 'RECEIVER',
}

export const tabsTitle = {
  basicInfo: 'basic-info',
  docUpload: 'doc-upload',
  offerLoadContact: 'offer-load-contact',
  offerLoad: 'offer-load',
}

export const quickConfirmationTabs = {
  loaderInfo: 'loader-info',
  truckerInfo: 'trucker-info',
  confirmationInfo: 'confirmation-info',
  paymentInfo: 'payment-info',
}

// Mirrors OfferUseState in navodaya-node-api/src/modules/offer/constants.ts
export const quickConfirmationOfferUseState = {
  usable: 'usable',
  confirmationPending: 'confirmation_pending',
  usedInOtherQuickConfirmation: 'used_in_other_quick_confirmation',
}

export const confirmationTabs = {
  basicInfo: 'basic-info',
  paymentInfo: 'payment-info',
  trackingInfo: 'tracking-info',
}

export const usersType = {
  loader: 'loader',
  trucker: 'trucker',
  drivers: 'drivers',
  trucks: 'trucks',
  banks: 'banks',
  routes: 'routes',
  offers: 'offers',
  ledger: 'ledger',
  loaders: 'loaders',
  truckers: 'truckers',
  employees: 'employees',
  driver: 'driver',
  employee: 'employee',
  branches: 'branches',
  loads: 'loads',
  mcBook: 'mc-book',
  admin: 'admin',
  offer: 'offer',
  load: 'load',
  addNewOffer: 'Offer',
  addNewLoad: 'Load',
  loadBoard: 'load-board',
  truckBoard: 'offer-board',
  users: 'users',
  confirmation: 'confirmation',
  loadSuggestions: 'loadSuggestions',
  pod: 'pod',
  operator: 'operator',
  hybridUser: 'hybrid-user',
  hybridUsers: 'hybrid user',
  hybridUsersDocType: 'hybrid',
  hybridUsersRouteType: 'hybrid-users',
  loadOperator: 'load_operator',
  truckOperator: 'truck_operator',
  accountOperator: 'account_operator',
  loaderOperator: 'Loader Operator',
  truckerOperator: 'Trucker Operator',
  accountsOperator: 'Accounts Operator',
  hybridUserCapital: 'Hybrid User',
  loadOffers: 'loadOffers',
}

/** Profile user types that show the Auto Payment Reminder setting (Admin/Operator only) */
export const profileUserTypesWithAutoPaymentReminder = [usersType.trucker, usersType.hybridUsersDocType] as const

export const docsType = {
  documents: 'documents',
  columns: {
    reason: 'reason',
  },
}
export const docsStatus = {
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
  expiring: 'Expiring',
}
export const userTableOptions: Record<string, any> = reactive({
  page: 1,
  limit: 10,
  sortField: null,
  sortOrder: null,
  search: false,
})

export const userDocTableOptions = reactive({
  page: 1,
  results: 100,
  sortField: null,
  sortOrder: null,
  search: true,
})

export const usersData = {
  id: '',
  business_name: null,
  trading_name: '',
  address: '',
  fullName: null,
  phone: '',
  mobiles: [''],
  landlines: [''],
  email: '',
  gst: '',
  notes: '',
  pan: '',
  place_id: '',
  place_name: '',
  place_latitude: '',
  place_longitude: '',
  place_reference: '',
  designation: '',
  website: '',
  aadhar: '',
  type: 'trucker',
  materials: [],
  industry: '',
  map_url: null,
  pincode: null,
}

export const offerInfo = reactive({
  primary_contact: {
    fullname: '',
    designation: '',
    email: '',
    mobiles: [],
    landlines: [],
  },
  alternative_contact: {
    fullname: '',
    designation: '',
    email: '',
    mobiles: [],
    landlines: [],
  },
})

export const offerDetails = reactive({
  truckNo: '',
  chassisNo: '',
  tyres: '',
  capacity: '',
  engineNo: '',
  availableArea: '',
  loadingDate: '',
  material: [],
  routes: [],
  notes: '',
  public: '',
  status: '',
  driver_details: {
    fullname: '',
    designation: '',
    email: '',
    mobiles: [],
    landlines: [],
  },
})

export const isPublic = [
  { id: '1', name: 'Yes' },
  { id: '0', name: 'No' },
]

export const isReceiving = ['Yes', 'No']

export const commissionOptions = ['MC Book', 'Cash', 'A/C Transfer']

export const availability = [
  { id: 'Available', name: 'Available' },
  { id: 'In process', name: 'In process' },
]

export const loaderTruckerAvailability = [
  { id: 'In process', name: 'In process' },
]

export const isPrimary = [
  { text: i18n.global.t('Yes'), value: 1 },
  { text: i18n.global.t('No'), value: 0 },
]

export let bankInfo = reactive({
  bank_name: '',
  bank_number: '',
  bank_ifsc_code: '',
  bank_branch_address: '',
  bank_type: null,
  bank_pan_number: '',
  account_name: '',
  is_default: isPrimary.at(0)?.value,
})

export const resetData = reactive({ ...usersData })

export const truckersProfileColumnsForOperator = [
  { name: 'Trucker ID', value: 'id' },
  { name: 'Business Name', value: 'business_name' },
  { name: 'Trading Name', value: 'trading_name' },
  { name: 'Address', value: 'address' },
  { name: 'Business Area', value: 'place_name' },
  { name: 'Business GST IN', value: 'gst' },
  { name: 'PAN No.', value: 'pan' },
  { name: 'Email Id', value: 'user_id', subValue: 'email' },
  { name: 'Designation', value: 'designation' },
  { name: 'Mobile No.', value: 'mobiles' },
  { name: 'Landline No.', value: 'landline' },
  { name: 'Balance', value: 'available_balance' },
]

export const truckersProfileColumns = [
  { name: 'Trucker ID', value: 'id' },
  { name: 'Business Name', value: 'business_name' },
  { name: 'Trading Name', value: 'trading_name' },
  { name: 'Address', value: 'address' },
  { name: 'Business Area', value: 'place_name' },
  { name: 'Business GST IN', value: 'gst' },
  { name: 'PAN No.', value: 'pan' },
  { name: 'Email Id', value: 'user_id', subValue: 'email' },
  { name: 'Designation', value: 'designation' },
  { name: 'Mobile No.', value: 'mobiles' },
  { name: 'Landline No.', value: 'landline' },
  { name: 'Website', value: 'web' },
]

export const usersOfferProfileColumns = [
  { name: 'Offer ID', value: 'id', is_bold: true },
  { name: 'Business Area', value: 'business_area' },
  { name: 'Business Name', value: 'business_name', is_bold: true },
  { name: 'Trucker ID', value: 'trucker_id' },
  { name: 'Business Cluster', value: 'businessOfferCluster' },
  { name: 'Trading Name', value: 'trading_name', is_bold: true },
  { name: 'Owner Name', value: 'primary', subValue: 'full_name' },
  { name: 'Driver Name', value: 'driver', subValue: 'full_name' },
  { name: 'Truck No', value: 'truck_number' },
  { name: 'Owner Mobile No.', value: 'ownerNo' },
  { name: 'Driver Mobile No.', value: 'driverNo' },
  { name: 'Tyres/Capacity Range', value: 'tyres', is_bold: true },
  { name: 'Alt Name', value: 'alternative', subValue: 'full_name' },
  { name: 'Preferred Routes', value: 'routes' },
  { name: 'Available Area', value: 'area', is_bold: true },
  { name: 'Alt Mobile No.', value: 'alternativeNo' },
  { name: 'Pref. Materials / Products', value: 'product', subValue: 'material' },
  { name: 'Available Date', value: 'loading_date' },
  { name: 'Created Timestamp', value: 'created_at' },
  { name: 'Conditions', value: 'conditions' },
  { name: 'Offer Cluster', value: 'clusters', is_bold: true },
  { name: 'Updated Timestamp', value: 'updated_at' },
  { name: 'Notes', value: 'notes' },
  { name: 'Status', value: 'status', is_bold: true },
]

export const adminOfferProfileColumns = [
  { name: 'Offer ID', value: 'id', is_bold: true },
  { name: 'Business Area', value: 'business_area' },
  { name: 'Business Name', value: 'business_name', is_bold: true },
  { name: 'Trucker ID', value: 'trucker_id' },
  { name: 'Business Cluster', value: 'businessOfferCluster' },
  { name: 'Trading Name', value: 'trading_name', is_bold: true },
  { name: 'Owner Name', value: 'primary', subValue: 'full_name' },
  { name: 'Driver Name', value: 'driver', subValue: 'full_name' },
  { name: 'Truck No', value: 'truck_number' },
  { name: 'Owner Mobile No.', value: 'ownerNo' },
  { name: 'Driver Mobile No.', value: 'driverNo' },
  { name: 'Tyres/Capacity Range', value: 'tyres', is_bold: true },
  { name: 'Alt Name', value: 'alternative', subValue: 'full_name' },
  { name: 'Preferred Routes', value: 'routes' },
  { name: 'Available Area', value: 'area', is_bold: true },
  { name: 'Alt Mobile No.', value: 'alternativeNo' },
  { name: 'Pref. Materials / Products', value: 'product', subValue: 'material' },
  { name: 'Available Date', value: 'loading_date' },
  { name: 'Created Timestamp', value: 'created_at' },
  { name: 'Conditions', value: 'conditions' },
  { name: 'Offer Cluster', value: 'clusters', is_bold: true },
  { name: 'Updated Timestamp', value: 'updated_at' },
  { name: '', value: '' },
  { name: 'Status', value: 'status', is_bold: true },
  { name: 'Visibility', value: 'is_public' },
  { name: 'Notes', value: 'notes' },
  { name: 'Balance', value: 'available_balance' },
]

export const adminLoadProfileColumns = [
  { name: 'Load ID', value: 'id', is_bold: true },
  { name: 'Business Area', value: 'area' },
  { name: 'Business Name', value: 'business_name', is_bold: true },
  { name: 'Loader ID', value: 'loader_id' },
  { name: 'Business Cluster', value: 'businessCluster' },
  { name: 'Trading Name', value: 'trading_name', is_bold: true },
  { name: 'Pri Name', value: 'primary', subValue: 'full_name' },
  { name: 'Alt Name', value: 'alternative', subValue: 'full_name' },
  { name: 'FR + PR + OR + Misc.', value: 'fr_pr_or' },
  { name: 'Pri Mobile No.', value: 'ownerNo' },
  { name: 'Alt Mobile No.', value: 'alternativeNo' },
  { name: 'Adv + To Pay + POD', value: 'adv_pay_pod' },
  { name: 'Loading Mobile No.', value: 'loadingMobileNo', subValue: 'preferred_contact', is_bold: true },
  { name: 'Loading Charges', value: 'loading_charges', subValue: 'charges', is_bold: true },
  { name: 'Loading Points', value: 'loading_points', subValue: 'place_name', is_bold: true },
  { name: 'Unloading Mobile No.', value: 'unloadingMobileNo', subValue: 'preferred_contact', is_bold: true },
  { name: 'Unloading Charges', value: 'unloading_charges', subValue: 'charges', is_bold: true },
  { name: 'Unloading Points', value: 'unloading_points', subValue: 'place_name', is_bold: true },
  { name: 'Conditions', value: 'conditions' },
  { name: 'Freight Method', value: 'freight_method' },
  { name: 'Capacity', value: 'capacity', is_bold: true },
  { name: 'Industry', value: 'industry', subValue: 'industry' },
  { name: 'Materials / Products', value: 'product', subValue: 'material' },
  { name: 'Loading Date', value: 'loading_date' },
  { name: 'Created Timestamp', value: 'created_at' },
  {
    name: 'Targeted Route',
    value: 'targeted_route',
  },
  { name: 'Loading Cluster', value: 'cluster', is_bold: true },
  { name: 'Updated Timestamp', value: 'updated_at' },
  {
    name: 'Total Distance',
    value: 'total_distance',
  },
  { name: 'Status', value: 'status', is_bold: true },
  { name: 'Visibility', value: 'is_public' },
  { name: 'Notes', value: 'notes' },
  { name: 'Balance', value: 'available_balance' },
]

export const usersLoadProfileColumns = [
  { name: 'Load ID', value: 'id', is_bold: true },
  { name: 'Business Area', value: 'area' },
  { name: 'Business Name', value: 'business_name', is_bold: true },
  { name: 'Loader ID', value: 'loader_id' },
  { name: 'Business Cluster', value: 'businessCluster' },
  { name: 'Trading Name', value: 'trading_name', is_bold: true },
  { name: 'Pri Name', value: 'primary', subValue: 'full_name' },
  { name: 'Alt Name', value: 'alternative', subValue: 'full_name' },
  { name: 'FR + PR + OR + Misc.', value: 'fr_pr_or' },
  { name: 'Pri Mobile No.', value: 'ownerNo' },
  { name: 'Alt Mobile No.', value: 'alternativeNo' },
  { name: 'Adv + To Pay + POD', value: 'adv_pay_pod' },
  { name: 'Loading Mobile No.', value: 'loadingMobileNo', subValue: 'preferred_contact', is_bold: true },
  { name: 'Loading Charges', value: 'loading_charges', subValue: 'charges', is_bold: true },
  { name: 'Loading Points', value: 'loading_points', subValue: 'place_name', is_bold: true },
  { name: 'Unloading Mobile No.', value: 'unloadingMobileNo', subValue: 'preferred_contact', is_bold: true },
  { name: 'Unloading Charges', value: 'unloading_charges', subValue: 'charges', is_bold: true },
  { name: 'Unloading Points', value: 'unloading_points', subValue: 'place_name', is_bold: true },
  { name: 'Conditions', value: 'conditions' },
  { name: 'Freight Method', value: 'freight_method' },
  { name: 'Capacity', value: 'capacity', is_bold: true },
  { name: 'Industry', value: 'industry', subValue: 'industry' },
  { name: 'Materials / Products', value: 'product', subValue: 'material' },
  { name: 'Loading Date', value: 'loading_date' },
  { name: 'Created Timestamp', value: 'created_at' },
  { name: '', value: '' },
  { name: 'Status', value: 'status', is_bold: true },
  { name: 'Updated Timestamp', value: 'updated_at' },
  { name: '', value: '' },
  { name: 'Notes', value: 'notes' },
]

export const loadersProfileColumnsForOperator = [
  { name: 'Loader ID', value: 'id' },
  { name: 'Business Name', value: 'business_name' },
  { name: 'Trading Name', value: 'trading_name' },
  { name: 'Materials / Products', value: 'materials' },
  { name: 'Business Area', value: 'place_name' },
  { name: 'Business GST IN', value: 'gst' },
  { name: 'Industry', value: 'preferred_industries' },
  { name: 'Email Id', value: 'user_id', subValue: 'email' },
  { name: 'Designation', value: 'designation' },
  { name: 'Mobile No.', value: 'mobiles' },
  { name: 'Landline No.', value: 'landline' },
  { name: 'Balance', value: 'available_balance' },
]

export const loadersProfileColumns = [
  { name: 'Loader ID', value: 'id' },
  { name: 'Business Name', value: 'business_name' },
  { name: 'Trading Name', value: 'trading_name' },
  { name: 'Materials / Products', value: 'materials' },
  { name: 'Business Area', value: 'place_name' },
  { name: 'Business GST IN', value: 'gst' },
  { name: 'Industry', value: 'preferred_industries' },
  { name: 'Email Id', value: 'user_id', subValue: 'email' },
  { name: 'Designation', value: 'designation' },
  { name: 'Mobile No.', value: 'mobiles' },
  { name: 'Landline No.', value: 'landline' },
  { name: 'Website', value: 'web' },
]

export const profileListType = {
  materials: 'materials',
  industries: 'preferred_industries',
  website: 'web',
  mobiles: 'mobiles',
  landline: 'landline',
  email: 'email',
}

export const truckerTabs = [
  { icon: 'tabler-user', title: 'Drivers', key: 'driver_count', type: 'drivers', msgKey: 'drivers', msgType: 'driver' },
  { icon: 'tabler-truck', title: 'Trucks', key: 'truck_count', type: 'trucks', msgKey: 'trucks', msgType: 'truck' },
  { icon: 'tabler-square-chevron-down', title: 'Offers', key: 'offer_count', type: 'offers', msgKey: 'offers', msgType: 'offer' },
  { icon: 'tabler-building-bank', title: 'Banks', key: 'bank_count', type: 'banks', msgKey: 'banks', msgType: 'bank' },
  { icon: 'tabler-clipboard-text', title: 'Ledgers', type: 'ledger', msgKey: 'ledgers', msgType: 'ledger' },
  { icon: 'tabler-notebook', title: 'MC Books', type: 'mc-book', msgKey: 'mc books', module: 'MC Book', msgType: 'mc book' },
]

export const LoaderTabs = [
  { icon: 'tabler-user', title: 'Employees', key: 'employee_count', type: 'employees', msgKey: 'employees', msgType: 'employee' },
  { icon: 'tabler-truck', title: 'Branches', key: 'branch_count', type: 'branches', msgKey: 'branches', msgType: 'branch' },
  { icon: 'tabler-square-chevron-down', title: 'Loads', key: 'load_count', type: 'loads', msgKey: 'loads', msgType: 'load' },
  { icon: 'tabler-building-bank', title: 'Banks', key: 'bank_count', type: 'banks', msgKey: 'banks', msgType: 'bank' },
  { icon: 'tabler-clipboard-text', title: 'Ledgers', type: 'ledger', msgKey: 'ledgers', msgType: 'ledger' },
  { icon: 'tabler-notebook', title: 'MC Books', type: 'mc-book', msgKey: 'mc books', module: 'MC Book', msgType: 'mc book' },
]

export const truckerSearchFields: any = reactive({
  isActive: null,
  id: '',
  fullname: '',
  fullName: '',
  mobiles: '',
  mobile: '',
  landline: '',
  landlines: '',
  email: '',
  designation: '',
  truck_number: '',
  chassis_number: '',
  tyres: '',
  capacity: '',
  engine_number: '',
  primary_fullname: '',
  ownerMobileNo: '',
  driver_fullname: '',
  cluster_place_name: null,
  availableArea: '',
  availableDate: '',
  status: '',
  visibility: '',
  accountName: '',
  bankName: '',
  bankNumber: '',
  bankIfscCode: '',
  bankBranchAddress: '',
  bankType: null,
  bankPanNumber: '',
  is_docs_verified: '',
  confirmationId: '',
  remark: null,
  route_place_name: null,
  description: '',
  paymentType: null,
  reference: '',
  businessName: '',
  trading_name: '',
  place_name: '',
  charges: '',
  routes: null,
  material: null,
  alternative_fullname: '',
  preferred_routes: '',
  available_date: '',
  preferred_contact: '',
  preferred_materials: null,
  alternative_mobiles: '',
  loading_place_name: '',
  unloading_place_name: '',
  load_material_industry: null,
  industry_load_material_industry: null,
  freight_per_ton: '',
  loading_charges: '',
  loading_date: null,
  unloading_charges: '',
  freight_method: null,
  conditions: null,
  is_public: null,
  business_area: '',
  loading_mobiles: '',
  unloading_mobiles: '',
  truckerId: '',
  preferred_route: '',
  locked: '',
  is_lock: null,
  length: '',
  primary_preferred_contact: '',
  driver_preferred_contact: '',
  toDate: null,
  fromDate: null,
  amountType: null,
  paymentMethod: null,
  workableType: null,
  is_active: '',
  gst: null,
  website: null,
  targeted_route_id: '',
  license_number: '',
})

export const resetTruckerFields = { ...truckerSearchFields }

export const resetEmployeeFields = { ...employeeSearchFields }

export const isLocked = [
  { text: i18n.global.t('Yes'), value: 'yes' },
  { text: i18n.global.t('No'), value: 'no' },
]

export const tabType = {
  drivers: 'drivers',
  trucks: 'trucks',
  banks: 'banks',
  employees: 'employees',
  branches: 'branches',
  loads: 'loads',
  offers: 'offers',
  mcBook: 'mc-book',
  ledger: 'ledger',
}

export const usersBulkStatus = {
  active: 'Active',
  inActive: 'Inactive',
  verified: 'Verified',
  unverified: 'Unverified',
  delete: 'Delete',
  docVerified: 'Doc Verified',
  docUnverified: 'Doc Unverified',
}

export const usersTooltip = {
  active: 'Active',
  inActive: 'Inactive',
}

export const acceptedFiles = ['.jpg', '.jpeg', '.png', '.pdf']

export const acceptedImages = ['.jpg', '.jpeg', '.png']

export const LoaderTruckerColumnName = {
  maxLoadingCluster: 'max_loading_cluster',
  maxUnloadingRoute: 'max_unloading_route',
  maxTraveledCluster: 'max_travelled_cluster',
}

export const usersDefaultValues = {
  customUsersTableValues: 2,
  noOfPhoneField: 3,
  defaultDataTableByTruckers: [1, 3, 5],
  defaultDataTableByLoaders: [3, 5],
  hasCustomTable: ['drivers', 'employees', 'branches'],
  status: 'Status',
  actions: 'actions',
  isLedgerTable: 4,
  backspaceKeyCode: 8,
  tabCode: 9,
  landline: 'landline',
  mobileLength: 10,
  error: 'error',
  tyres: '12',
  capacity: '1',
  loadingDate: new Date(),
  adminVisibility: 1,
  userVisibility: 0,
  adminStatus: 'Available',
  loaderTruckerStatus: 'In process',
  freightMethod: 'per_ton',
  selectedTypeDate: 4,
  confirmationLink: 'Confirmation Link',
  smsSentReport: 'SMS Sent Report',
}

export const offerAndLoadSubItems = {
  notes: 'notes',
  industry: 'industry',
  product: 'product',
  conditions: 'conditions',
  routes: 'routes',
  freightDetails: 'fr_pr_or',
  freightLoader: 'FR + PR ',
  loadingPoints: 'loading_points',
  LoadingMobileNo: 'loadingMobileNo',
  UnloadingMobileNo: 'unloadingMobileNo',
  unloadingPoints: 'unloading_points',
  loadingCharges: 'loading_charges',
  unloadingCharges: 'unloading_charges',
  placeName: 'area',
  businessArea: 'business_area',
  cluster: 'clusters',
  area: 'area',
  remark: 'remark',
  ownerNo: 'ownerNo',
  driverNo: 'driverNo',
  alternativeNo: 'alternativeNo',
  materials: 'materials',
  capacity: 'capacity',
  mobiles: 'mobiles',
  business_name: 'business_name',
  loadCapacity: 'loadCapacity',
}

export const statusChipColor: any = {
  'In process': 'info',
  'Available': 'success',
  'Confirmed': 'success',
  'Expiring': 'warning',
  'Cancelled': 'error',
  'Expired': 'error',
  'Completed': 'purple',
  'Pending': 'warning',
  'Booked': 'process-blue',
  'captured': 'success',
  'failed': 'error',
  'created': 'warning',
  'Paid': 'success',
  'Partially Paid': 'warning',
  'Not Paid': 'grey-500',
}

export const statusValue: any = {
  cancelled: 'Cancelled',
  paid: 'Paid',
  expired: 'Expired',
  expiring: 'Expiring',
  available: 'Available',
  inProcess: 'In process',
}

export const acceptDocFiles = 'image/png, image/jpg, images/jpeg, application/pdf'

export const getCapacityFromFreightMethod = (data: any) => {
  const mapping: any = {
    total_freight: `${data?.total_load_weight} tons`,
    per_ton: `${data?.total_load_weight} tons`,
    per_unit: `${data?.per_unit_quantity} units`,
  }

  return mapping?.[data?.freight_method]
}

export const displayLoadsList = (col: string, data: any) => {
  const { load_payment_infos } = data

  const paymentInfo = load_payment_infos?.at(0)

  const { freight_amount, freight_method, pr_amount, or_amount, advance_amount, to_pay_amount, pod_amount, total_load_weight, per_unit_quantity, misc, additional_charges } = paymentInfo || {}

  const clusters_place_name = data?.cluster_id?.place_name ? extractCityStateListing(data?.cluster_id?.place_name) : null

  if (col === 'loader_id')
    return data?.is_hybrid ? data?.loader_id?.hybrid_user?.id : data?.[col]?.id
  if (col === 'loaders_place_name')
    return data?.loader_id?.place_name ? extractCityStateListing(data?.loader_id?.place_name) : ''
  if (col === 'loaders_business_name')
    return data?.loader_id?.business_name
  if (col === 'loaders_trading_name')
    return data?.loader_id?.trading_name
  if (col === 'loading_place_name')
    return data[col] !== null ? data?.[col]?.split(',').at(0) : ''
  if (col === 'load_industry')
    return data[col] || data?.loads_materials_industries?.at(0)?.industry_id?.name
  if (col === 'freight_method')
    return loadsFreight.find((i: { value: string }) => i.value === freight_method)?.text
  if (col === 'capacity') {
    return getCapacityFromFreightMethod({
      capacity: data?.capacity,
      freight_method,
      total_load_weight,
      per_unit_quantity,
    })
  }
  if (col === 'is_public')
    return visibility.find(item => item.value === data[col]?.toString())?.text
  if (col === 'fr_pr_or')
    return `${getFormattedAmount(Number(freight_amount) + Number(additional_charges))} + ${getFormattedAmount(Number(pr_amount))} + ${getFormattedAmount(Number(or_amount))} + ${getFormattedAmount(Number(misc))}`
  if (col === 'delivery')
    return `${getFormattedAmount(Number(advance_amount))} + ${getFormattedAmount(Number(to_pay_amount))} + ${getFormattedAmount(Number(pod_amount))}`
  if (col === 'clusters_place_name')
    return clusters_place_name ? (`${clusters_place_name} ${(isAdminOrOperator.value && data?.cluster_distance) ? `(${data?.cluster_distance})` : ''}`) : ''
  if (col === 'businessCluster')
    return data?.loader_id?.cluster_id?.place_name ? extractCityStateListing(data?.loader_id?.cluster_id?.place_name) : ''
  if (col === 'targeted_route')
    return data?.route?.display_name ? (`${data?.route?.display_name} ${(isOperator.value && data.kms) ? `(${data?.kms})` : ''}`) : ''
  if (col === 'primary_fullname')
    return data?.primary?.at(0)?.full_name
  if (col === 'alternative_fullname')
    return data?.alternative?.at(0)?.full_name

  return data[col]
}

const getBankBusinessId = (user: any) => {
  if (user?.hybrid_user?.id)
    return `(ID: ${user.hybrid_user.id} - Hybrid User)`
  if (user?.loader?.id)
    return `(ID: ${user.loader.id} - Loader)`
  if (user?.trucker?.id)
    return `(ID: ${user.trucker.id} - Trucker)`

  return ''
}

// A hybrid user's business name lives on its loader record
const getBankBusinessName = (user: any) => {
  const businessName = user?.hybrid_user ? user.hybrid_user.loader?.business_name : (user?.loader?.business_name || user?.trucker?.business_name || '')

  return `${businessName} ${getBankBusinessId(user)}`
}

const getEmployeeParentId = (employee: any) => {
  if (employee?.loader?.hybrid_user?.id)
    return `(ID: ${employee.loader.hybrid_user.id} - Hybrid User)`
  if (employee?.loader?.id)
    return `(ID: ${employee.loader.id} - Loader)`
}

const getDriverParentId = (driver: any) => {
  if (driver?.trucker?.hybrid_user?.id)
    return `(ID: ${driver.trucker.hybrid_user.id} - Hybrid User)`
  if (driver?.trucker?.id)
    return `(ID: ${driver.trucker.id} - Trucker)`
}

const getBranchParentId = (document: any) => {
  const loader = document?.branches?.loader
  if (loader?.hybrid_user?.id)
    return `(ID: ${loader.hybrid_user.id} - Hybrid User)`
  if (loader?.id)
    return `(ID: ${loader.id} - Loader)`
}

const getTruckParentId = (truck: any) => {
  if (truck?.trucker_id?.hybrid_user?.id)
    return `(ID: ${truck.trucker_id.hybrid_user.id} - Hybrid User)`
  if (truck?.trucker_id?.id)
    return `(ID: ${truck.trucker_id.id} - Trucker)`
}

// Loads/offers carry their own business name; the owner suffix is dropped when no loader/trucker is linked
const getLoadBusinessName = (load: any) => {
  if (!load?.business_name)
    return ''
  if (load.loader_id?.hybrid_user?.id)
    return `${load.business_name} (ID: ${load.loader_id.hybrid_user.id} - Hybrid User)`
  if (load.loader_id?.id)
    return `${load.business_name} (ID: ${load.loader_id.id} - Loader)`

  return load.business_name
}

const getOfferBusinessName = (offer: any) => {
  if (!offer?.business_name)
    return ''
  if (offer.trucker_id?.hybrid_user?.id)
    return `${offer.business_name} (ID: ${offer.trucker_id.hybrid_user.id} - Hybrid User)`
  if (offer.trucker_id?.id)
    return `${offer.business_name} (ID: ${offer.trucker_id.id} - Trucker)`

  return offer.business_name
}

const getBusinessName = (document: any) => {
  const mapping: any = {
    loader: `${document?.loaders?.business_name} (ID: ${document?.loaders?.id} - Loader)`,
    trucker: `${document?.truckers?.business_name} (ID: ${document?.truckers?.id} - Trucker)`,
    hybrid: `${document?.loaders?.business_name} (ID: ${document?.hybrid_users?.id} - Hybrid User)`,
    employee: document?.employees?.loader?.business_name ? `${document?.employees?.loader?.business_name} ${getEmployeeParentId(document?.employees)}` : getLoadBusinessName(document?.employees?.contacts),
    driver: document?.drivers?.trucker?.business_name ? `${document?.drivers?.trucker?.business_name} ${getDriverParentId(document?.drivers)}` : getOfferBusinessName(document?.drivers?.contacts),
    branch: document?.branches?.loader?.business_name ? `${document?.branches?.loader?.business_name} ${getBranchParentId(document)}` : getLoadBusinessName(document?.loading_points?.load_id || document?.unloading_points?.load_id),
    truck: document?.trucks?.trucker_id?.business_name ? `${document?.trucks?.trucker_id?.business_name} ${getTruckParentId(document?.trucks)}` : getOfferBusinessName(document?.trucks?.offers),
    bank: getBankBusinessName(document?.banks?.user_id),
    confirmation: document?.confirmation_business_name,
    pod: document?.podDocuments_business_name,
    load_operator: `ID: ${document.documentable_id} - Loader Operator`,
    truck_operator: `ID: ${document.documentable_id} - Trucker Operator`,
    account_operator: `ID: ${document.documentable_id} - Accounts Operator`,
  }

  return mapping?.[document?.document_type_id?.type] || ''
}

const getEmployeeBusinessId = (employee: any) => {
  return employee?.contacts?.id ? `${employee.contacts.id} (Load)` : 'N/A'

  // if (employee?.loader?.hybrid_user?.id)
  //   return `${employee.loader.hybrid_user.id} (Hybrid User)`
  // if (employee?.loader?.id)
  //   return `${employee.loader.id} (Loader)`
}

const getDriverBusinessId = (driver: any) => {
  return driver?.contacts?.id ? `${driver.contacts.id} (Offer)` : 'N/A'

  // if (driver?.trucker?.hybrid_user?.id)
  //   return `${driver.trucker.hybrid_user.id} (Hybrid User)`
  // if (driver?.trucker?.id)
  //   return `${driver.trucker.id} (Trucker)`
}

const getBranchBusinessId = (document: any) => {
  // const loader = document?.branches?.loader
  const loadId = document?.loading_points?.load_id?.id || document?.unloading_points?.load_id?.id

  return loadId ? `${loadId} (Load)` : 'N/A'

  // if (loader?.hybrid_user?.id)
  //   return `${loader.hybrid_user.id} (Hybrid User)`
  // if (loader?.id)
  //   return `${loader.id} (Loader)`
  // if (loadId)
  //   return `${loadId} (Load)`
}

const getTruckBusinessId = (truck: any) => {
  return truck?.offer_id ? `${truck.offer_id} (Offer)` : 'N/A'

  // if (truck?.trucker_id?.hybrid_user?.id)
  //   return `${truck.trucker_id.hybrid_user.id} (Hybrid User)`
  // if (truck?.trucker_id?.id)
  //   return `${truck.trucker_id.id} (Trucker)`
  // if (truck?.offer_id)
  //   return `${truck.offer_id} (Offer)`
}

const getBusinessId = (document: any) => {
  const mapping: any = {
    loader: 'N/A',
    trucker: 'N/A',
    hybrid: 'N/A',
    employee: getEmployeeBusinessId(document?.employees),
    driver: getDriverBusinessId(document?.drivers),
    branch: getBranchBusinessId(document),
    truck: getTruckBusinessId(document?.trucks),
    bank: 'N/A',
    confirmation: 'N/A',
    pod: 'N/A',
  }

  return mapping?.[document?.document_type_id?.type] || ''
}

const docUploadQuery = `?from=${tabsTitle.docUpload}`

// A hybrid user's employees/branches/drivers/trucks are managed from the hybrid profile, not its loader/trucker one
const getSubEntityRoute = (owner: any, ownerType: string, submodule: string, id: number) => {
  if (!owner?.user_id?.uuid)
    return

  const profileType = owner.hybrid_user?.id ? usersType.hybridUsersDocType : ownerType

  return `/users/${profileType}/${owner.user_id.uuid}/${submodule}/edit/${id}${docUploadQuery}`
}

const getConfirmationRoute = (uuid: string, docType: string, pointId?: number) => {
  if (!uuid)
    return

  return `/confirmations/view/${uuid}?docType=${docType}${pointId ? `&pointId=${pointId}` : ''}`
}

const getBankRoute = (bank: any) => {
  const user = bank?.user_id
  const profileType = (user?.hybrid_user?.id && usersType.hybridUsersDocType) || (user?.loader?.id && usersType.loader) || (user?.trucker?.id && usersType.trucker)

  if (user?.uuid && profileType)
    return `/users/${profileType}/${user.uuid}/banks/edit/${bank.id}${docUploadQuery}`
}

// Where a document was uploaded; load/offer documents resolve to that load's/offer's latest confirmation
export const getDocumentSourceRoute = (document: any) => {
  const type = document?.document_type_id?.type
  const id = document?.documentable_id
  const userUuid = document?.users?.uuid
  const latestConfirmationUuid = document?.latest_confirmation_uuid

  if ([usersType.loader, usersType.trucker, usersType.hybridUsersDocType].includes(type))
    return userUuid && `/users/${type}/edit/${userUuid}${docUploadQuery}`

  if ([usersType.loadOperator, usersType.truckOperator, usersType.accountOperator].includes(type))
    return userUuid && `/users/${usersType.operator}/edit/${userUuid}${docUploadQuery}`

  if (type === 'employee')
    return getSubEntityRoute(document.employees?.loader, usersType.loader, 'employees', id) || getConfirmationRoute(latestConfirmationUuid, transactionDocumentTypes.employee)

  if (type === 'driver')
    return getSubEntityRoute(document.drivers?.trucker, usersType.trucker, 'drivers', id) || getConfirmationRoute(latestConfirmationUuid, transactionDocumentTypes.driver)

  if (type === 'truck')
    return getSubEntityRoute(document.trucks?.trucker_id, usersType.trucker, 'trucks', id) || getConfirmationRoute(latestConfirmationUuid, transactionDocumentTypes.truck)

  if (type === 'branch') {
    const loadingPointId = document.loading_points?.id
    const pointType = loadingPointId ? transactionDocumentTypes.loadingPoint : transactionDocumentTypes.unloadingPoint

    return getSubEntityRoute(document.branches?.loader, usersType.loader, 'branches', id) || getConfirmationRoute(latestConfirmationUuid, pointType, loadingPointId || document.unloading_points?.id)
  }

  if (type === 'bank')
    return getBankRoute(document.banks)

  if (['confirmation', 'pod'].includes(type)) {
    const { confirmation, unloading_point_id } = document.confirmation_documents || {}

    return getConfirmationRoute(confirmation?.uuid, transactionDocumentTypes.unloadingPoint, unloading_point_id)
  }
}

const getType = (document: any) => {
  const type = capitalized(document?.document_type_id?.type)
  if (['employee', 'driver', 'branch', 'truck', 'bank'].includes(document?.document_type_id?.type))
    return `${type} (ID: ${document?.documentable_id})`

  return type
}

export const displayDocumentsList = (key: string, document: any) => {
  const keyMap: Record<string, any> = {
    'type': getType(document),
    'is_primary': isValue(document?.document_type_id?.is_primary),
    'is_public': isConfidential(document?.document_type_id?.is_public),
    'has_expiry': isValue(document?.document_type_id?.has_expiry),
    'owner.confirmation.formatted_id': document?.confirmation_documents?.confirmation?.formatted_id ? document?.confirmation_documents?.confirmation?.formatted_id : 'N/A',
    'valid_from': document?.valid_from ? formatDateWithoutTime(document?.valid_from) : '',
    'valid_to': document?.valid_to ? formatDateWithoutTime(document?.valid_to) : '',
    'business_name': getBusinessName(document),
    'business_id': getBusinessId(document),
  }

  return keyMap[key] || document[key]
}

export const displayOffersList = (col: string, data: any) => {
  if (col === 'place_name')
    return data?.trucker_id?.[col]
  if (col === 'trading_name')
    return data?.trucker_id?.[col]
  if (col === 'fullname' || col === 'phone')
    return data?.trucker?.user[col]
  if (col === 'primary_fullname')
    return data?.primary?.at(0)?.full_name || ''
  if (col === 'driver_fullname')
    return data?.driver?.at(0)?.full_name || ''
  if (col === 'driver_mobiles')
    return data?.driver?.at(0)?.mobiles?.at(0)?.value || ''
  if (col === 'alternative_fullname')
    return data?.alternative?.at(0)?.full_name || ''
  if (col === 'alternative_mobiles')
    return data?.alternative?.at(0)?.mobiles?.at(0)?.value || ''
  if (col === 'conditions')
    return data[col]?.at(0)?.name || ''
  if (col === 'is_public')
    return offerOrLoadVisibility.find(item => item.value === data[col])?.text
  if (col === 'capacity')
    return truckTyreCapacity.find(item => item.id === data[col]?.toString())?.value
  if (col === 'tyres')
    return `${truckTyreCapacity.find(item => item.mappedValue === data.mapped_tyres)?.tyreUpdatedTitle} / ${truckTyreCapacity.find(item => item.id === data?.capacity?.toString())?.value}`
  if (col === 'businessCluster')
    return data?.trucker_id?.cluster_id?.place_name ? extractCityStateListing(data?.trucker_id?.cluster_id?.place_name) : ''
  if (col === 'trucker_id')
    return data?.is_hybrid ? data?.trucker_id?.hybrid_user?.id : data?.trucker_id?.id

  return data[col]
}

export const displayRowValue = (subItem: { value: string; subValue: string }, data: any) => {
  if (subItem.value === 'trucker')
    return data[subItem.value]?.place_name
  if (subItem.value === 'trading_name')
    return data.trucker?.trading_name
  if (subItem.value === 'freight_method')
    return loadsFreight.find((i: { value: string }) => i.value === data[subItem.value])?.text
  if (subItem.value === 'capacity')
    return truckTyreCapacity.find(item => item.id === data?.[subItem.value]?.toString())?.value
  if (subItem.value === 'is_public')
    return data[subItem.value] ? 'Public' : 'Private'
  if (subItem.subValue === 'mobiles')

    return data[subItem.value]?.at(0)?.[subItem?.subValue]?.at(0)?.value
  if (subItem.value === 'place_name')
    return data.cluster?.place_name
  if (subItem.subValue)
    return data[subItem.value]?.at(0)?.[subItem?.subValue]

  return data[subItem.value]
}

export const OfferOrLoadColumnName = {
  fr_pr_or: 'fr_pr_or',
  adv_pay_pod: 'adv_pay_pod',
  trucker: 'trucker',
  trading_name: 'trading_name',
  freight_method: 'freight_method',
  capacity: 'capacity',
  is_public: 'is_public',
  mobiles: 'mobiles',
  place_name: 'place_name',
  loader: 'loader',
}

export const displayOfferOrLoadProfileValue = (subItem: { value: string; subValue: string }, data: any) => {
  if (subItem.value === OfferOrLoadColumnName.fr_pr_or)
    return `${getFormattedAmount(Number(data?.load_payment_infos?.at(0)?.freight_amount ?? 0) + Number(data?.load_payment_infos?.at(0)?.additional_charges ?? 0))} + ${getFormattedAmount(data?.load_payment_infos?.at(0)?.pr_amount ?? 0)} + ${getFormattedAmount(data?.load_payment_infos?.at(0)?.or_amount ?? 0)} + ${getFormattedAmount(data?.load_payment_infos?.at(0)?.misc ?? 0)}`
  if (subItem.value === OfferOrLoadColumnName.adv_pay_pod)
    return `${getFormattedAmount(data?.load_payment_infos?.at(0)?.advance_amount ?? 0)} + ${getFormattedAmount(data?.load_payment_infos?.at(0)?.to_pay_amount ?? 0)} + ${getFormattedAmount(data?.load_payment_infos?.at(0)?.pod_amount ?? 0)}`
  if (subItem.value === OfferOrLoadColumnName.trucker)
    return data[subItem.value]?.place_name
  if (subItem.value === OfferOrLoadColumnName.trading_name)
    return data.trucker_id?.trading_name || data.loader_id?.trading_name
  if (subItem.value === OfferOrLoadColumnName.freight_method) {
    return loadsFreight.find((i: { value: string }) => {
      return i.value === data?.load_payment_infos?.at(0)?.[subItem.value]
    })?.text
  }
  if (subItem.value === OfferOrLoadColumnName.capacity) {
    return getCapacityFromFreightMethod({
      capacity: data?.capacity,
      ...data?.load_payment_infos?.at(0),
    })
  }
  if (subItem.value === OfferOrLoadColumnName.is_public)
    return visibility.find(item => item.value === data[subItem.value]?.toString())?.text
  if (subItem.subValue === OfferOrLoadColumnName.mobiles)
    return data[subItem.value]?.at(0)?.[subItem?.subValue]?.at(0)?.value
  if (subItem.value === OfferOrLoadColumnName.place_name)
    return data.cluster_id?.place_name
  if (subItem.value === 'cluster')
    return `${extractCityStateListing(data.cluster_id?.place_name)} ${(isOperator.value && data?.cluster_distance) ? `(${data?.cluster_distance})` : ''}`
  if (subItem.value === OfferOrLoadColumnName.loader)
    return data[subItem.value]?.[subItem?.subValue]
  if (subItem.value === 'tyres')
    return `${truckTyreCapacity.find(item => item.mappedValue === data.mapped_tyres)?.tyreUpdatedTitle} / ${truckTyreCapacity.find(item => item.id === data?.capacity?.toString())?.value}`
  if (subItem.value === 'businessCluster')
    return data?.loader_id?.cluster_id?.place_name ? extractCityStateListing(data?.loader_id?.cluster_id?.place_name) : ''
  if (subItem.value === 'businessOfferCluster')
    return data?.trucker_id?.cluster_id?.place_name ? extractCityStateListing(data?.trucker_id?.cluster_id?.place_name) : ''
  if (subItem.subValue)
    return data[subItem.value]?.at(0)?.[subItem?.subValue]
  if (subItem.value === 'loader_id')
    return data?.is_hybrid ? data?.loader_id?.hybrid_user?.id : data?.loader_id?.id
  if (subItem.value === 'trucker_id')
    return data?.is_hybrid ? data?.trucker_id?.hybrid_user?.id : data?.trucker_id?.id
  if (subItem.value === 'business_name')
    return (data?.is_hybrid && isAdmin.value) ? `${data?.business_name} (H)` : data?.business_name

  return data[subItem.value]
}

export const displayUsersSubtypesValue = computed(() => (data: any, val: string) => {
  if (val === 'is_docs_verified')
    return data[val] ? 'Verified' : 'Unverified'
  if (val === 'is_active')
    return data[val] ? 'Active' : 'Inactive'
  if (val === 'created_at')
    return formatDate(data[val])
  if (val === 'updated_at')
    return formatDate(data[val])

  return Array.isArray(data[val]) ? data[val].at(0)?.value : data[val]
})

export const usersListType = {
  payer: 'Payer',
  preferredMaterials: 'Pref. Materials / Products',
  preferredRoutes: 'Preferred Routes',
  products: 'Materials / Products',
  conditions: 'Conditions',
  industry: 'Industry',
  cluster: 'Offer Cluster',
  truckCluster: 'Truck Available Cluster',
  availableArea: 'Available Area',
  driverNo: 'Driver Mobile No.',
  ownerNo: 'Owner Mobile No.',
  alternativeName: 'Alt Name',
  alternativeNo: 'Alt Mobile No.',
  primaryName: 'Pri Name',
  placeName: 'place_name',
  address: 'address',
  businessName: 'Business Name',
  charger: 'Hamali Charges',
  remark: 'Remarks',
  area: 'Area',
  loadingPoints: 'Loading Points',
  unloadingPoints: 'Unloading Points',
  UnloadingMobileNo: 'Unloading Mobile No.',
  LoadingMobileNo: 'Loading Mobile No.',
  freightAdmin: 'FR + PR + OR + Misc',
  freightLoader: 'FR + PR',
  freightTrucker: 'FR + Crossing',
  loadingCharges: 'Loading Charges',
  loadingCluster: 'Loading Cluster',
  unloadingCharges: 'Unloading Charges',
  loading_points: 'loadingPoints',
  materials: 'materials',
  unloading_points: 'unloadingPoints',
  business_area: 'Business Area',
  email: 'email',
  website: 'Website',
  mobileNo: 'Mobile No.',
  landlineNo: 'Landline No.',
  mobile: 'Mobile No.',
  mobiles: 'mobiles',
  landlines: 'landlines',
  primaryMobiles: 'primary_mobiles',
  altMobileNo: 'Alternate Mobile No.',
  designation: 'designation',
  primaryMobile: 'Pri Mobile No.',
  charges: 'charges',
  placeNameArea: 'placeName',
  createdDate: 'Created Timestamp',
  updatedDate: 'Updated Timestamp',
  lwh: 'lwh',
  material: 'Material',
  Email: 'Email Address',
  Address: 'Address',
  loaderId: 'Loader ID',
  truckerId: 'Trucker ID',
  hybridId: 'Hybrid User ID',
  notes: 'Notes',
  truckNo: 'Truck No.',
  leadDistance: 'Lead Distance',
  totalDistance: 'Total Distance',
  targetedRoute: 'Targeted Route',
  offerCluster: 'Offer Cluster',
  confirmationLeadDistance: 'Lead Distance / Truck Available Area',
  truckAvailableArea: 'Truck Available Area',
  truckAvailableCluster: 'Truck Available Cluster',
  availableBalance: 'available_balance',
  mapUrl: 'map_url',
  mapUrlType: 'mapUrl',
  truckerBusinessName: 'truckerBusinessName',
  invoiceValue: 'invoiceValue',
  status: 'status',
  mapUrlName: 'Map URL',
  loaderIdBalance: 'Loader ID / Balance',
  truckerIdBalance: 'Trucker ID / Balance',
  hybridIdBalance: 'Hybrid User ID / Balance',
}

export const messageModuleType = {
  offerSuggestion: 'offerSuggestion',
  loadSuggestion: 'loadSuggestion',
}

export const confirmationHistoryColumns = [
  { name: 'SR No.', value: 'index' },
  { name: 'CNF ID', value: 'formattedId' },
  { name: 'CNF Date', value: 'confirmedAt' },
  { name: 'Loader Business Name', value: 'loaderBusinessName' },
  { name: 'Trucker Business Name', value: 'truckerBusinessName' },
  { name: 'Loading Point', value: 'loadingPoints' },
  { name: 'Unloading Point', value: 'unloadingPoints' },
  { name: 'Materials', value: 'materials' },
  { name: 'Truck No.', value: 'truckNumber' },
  { name: 'Capacity', value: 'capacity' },
  { name: 'FR', value: 'freightAmount' },
  { name: 'PR', value: 'prAmount' },
  { name: 'OR', value: 'orAmount' },
  { name: 'Misc.', value: 'misc' },
]

export const loadingColumns = [
  { name: 'Business Name', value: 'business_name' },
  { name: 'Loading Point', value: 'place_name' },
  { name: 'Mobile No.', value: 'preferred_contact' },
  { name: 'Charges', value: 'charges' },
]

export const unloadingColumns = [
  { name: 'Business Name', value: 'business_name' },
  { name: 'Unloading Point', value: 'place_name' },
  { name: 'Mobile No.', value: 'preferred_contact' },
  { name: 'Charges', value: 'charges' },
]

export const loadingUnloadingPoint = ['loading_points', 'unloading_points']

export const paymentModeColumns = [
  { name: 'UTR No.', value: 'utr_no' },
  { name: 'Amount', value: 'amount' },
  { name: 'Paid To', value: 'paid_to' },
  { name: 'Date', value: 'date' },
  { name: 'Payment Mode', value: 'payment_mode' },
  { name: 'Receipt', value: 'receipt' },
]

export const smsSentReportColumns = [
  { title: 'Date & Time', key: 'createdAt', sortable: false },
  { title: 'Mobile No.', key: 'mobile', sortable: false },
  { title: 'Template', key: 'template', sortable: false },
  { title: 'Template Name', key: 'template.name', sortable: false },
  { title: 'SMS Status', key: 'status' },
]

export const waSentReportColumns = [
  { title: 'Date & Time', key: 'createdAt', sortable: false },
  { title: 'Mobile No.', key: 'mobile', sortable: false },
  { title: 'Template', key: 'template', sortable: false },
  { title: 'Template Name', key: 'template.name', sortable: false },
]

export const smsCampaign = [
  { title: 'Campaign', key: 'campaignId', sortable: false },
  { title: 'Type', key: 'type', sortable: false },
  { title: 'Date & Time', key: 'createdAt', sortable: false },
  { title: 'Campaign Status', key: 'status', sortable: false },
  { title: 'Total Count', key: 'messagesSent', sortable: false },
  { title: 'Message Type', key: 'messageType', sortable: false },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const routeOrClusterHeaderValue = ['pending', 'in_process', 'available', 'expiring', 'expired', 'cancelled', 'confirmed', 'completed']

export const hasViewByTypeForLatestConfirmation = ['loader_info', 'trucker_info']

export const userTypeForConfirmation: any = {
  loader: 1,
  trucker: 2,
}

export const usersSearchFields: ISearchUsers = reactive({
  id: '',
  businessName: '',
  placeName: '',
  clusterPlaceName: null,
  fullname: '',
  phone: '',
  tradingName: '',
  materials: null,
  industry: null,
  maxLoadingCluster: null,
  maxUnloadingRoute: null,
  isActive: null,
  verified: null,
  isDocsVerified: null,
  userType: null,
  notificationTitle: '',
  landlines: '',
  email: '',
  balance: null,
})

export const resetSearchFields = { ...usersSearchFields }

export const transactionStatus = [
  { text: i18n.global.t('Success'), value: 'captured' },
  { text: i18n.global.t('Pending'), value: 'created' },
  { text: i18n.global.t('Failed'), value: 'failed' },
]

export const transactionsSearchFields = reactive({
  confirmationId: '',
  transactionId: '',
  description: '',
  payment: '',
  fromDate: '',
  toDate: '',
  status: null,
})

export const transactionsTableOptions = reactive({
  page: 1,
  limit: 10,
  sortField: '',
  sortOrder: '',
})

export const statusOptions = [
  i18n.global.t('general.active'),
  i18n.global.t('general.inactive'),
]

export const userRoles = {
  admin: 'admin',
  loader: 'loader',
  trucker: 'trucker',
  accountOperator: 'account_operator',
  loaderOperator: 'loader_operator',
  truckerOperator: 'trucker_operator',
  hybrid: 'hybrid',
}
